import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Card, Badge, Th, Td, Empty, fmtDate } from "./ui";

export default function Verifications() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/verifications").then((r) => setRows(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <PageHeader title="Bedrijfsverificaties" subtitle="KvK & locatiecontrole met statusmachine" />
      <Card>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="border-b border-white/10"><tr><Th>Bedrijf</Th><Th>KvK</Th><Th>Registratie</Th><Th>Adres</Th><Th>Locatie</Th><Th>Maps</Th><Th>Status</Th><Th>Datum</Th></tr></thead>
            <tbody>
              {rows.map((v) => (
                <tr key={v.id} className="border-b border-white/5">
                  <Td>{v.submitted_company_name}</Td>
                  <Td>{v.kvk_number}</Td>
                  <Td className="text-white/50">{v.registration_status}</Td>
                  <Td className="text-white/50">{v.address_status}</Td>
                  <Td className="text-white/50">{v.business_location_status}</Td>
                  <Td className="text-white/50">{v.map_match_status}</Td>
                  <Td><Badge status={v.overall_status} /></Td>
                  <Td className="text-white/50">{fmtDate(v.created_at)}</Td>
                </tr>
              ))}
            </tbody>
          </table>
          {rows.length === 0 && <Empty text="Nog geen verificaties" />}
        </div>
      </Card>
    </div>
  );
}
